export enum TokenType {
  ERC721 = "erc721",
  ERC1155 = "erc1155",
}
